// webSocketReducer.js
import {
  RECEIVE_TRANSACTION_UPDATE,
  SUBSCRIBE_TO_TRANSACTION,
  UNSUBSCRIBE
} from '../Helper/webSocketActions';
import { produce } from 'immer';

const initialState = {
  transactions: {},
  subscribedTransactions: [],
  events: [] // List of transaction events
};

const webSocketReducer = (state = initialState, action) =>
  produce(state, draft => {
    switch (action.type) {
      case RECEIVE_TRANSACTION_UPDATE: {
        console.log('Received transaction update:', action.payload);
        const { deviceId, status, eventId, taskType, lastChangedAt, userId } =
          action.payload;
        const timestamp = new Date()
          .toISOString()
          .replace('T', ' ')
          .substring(0, 19); // Format to YYYY-MM-DD HH:MM:SS

        // Update transactions
        draft.transactions[eventId] = status;

        // Add or update events list (latest event at the start)
        draft.events.unshift({
          userId,
          labelId: deviceId,
          eventId,
          action: taskType,
          status,
          timestamp
        });

        break;
      }

      case SUBSCRIBE_TO_TRANSACTION:
        if (!draft.subscribedTransactions.includes(action.payload)) {
          draft.subscribedTransactions.push(action.payload);
        }
        break;

      case UNSUBSCRIBE:
        draft.subscribedTransactions = draft.subscribedTransactions.filter(
          subscription => subscription !== action.payload
        );
        break;

      default:
        break;
    }
  });

export default webSocketReducer;
